import { render, staticRenderFns } from "./Tutorials.vue?vue&type=template&id=4711d66a&"
import script from "./Tutorials.vue?vue&type=script&lang=ts&"
export * from "./Tutorials.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports